export default __webpack_public_path__ + "static/media/sounds/clpl_ready_Alyx.mp3";